import { Badge } from './badge';
import { cn } from '@/lib/utils';

export function DecisionBadge({ decision, className }: { decision?: string | null; className?: string }) {
  if (!decision) {
    return (
      <Badge variant="outline" className={cn('uppercase', className)}>
        Pending
      </Badge>
    );
  }
  let variant: 'default' | 'secondary' | 'outline' | 'destructive' = 'secondary';
  let label = '';
  switch (decision.toUpperCase()) {
    case 'PROMOTE':
      variant = 'default';
      label = 'Promote';
      break;
    case 'DEFER':
      variant = 'secondary';
      label = 'Defer';
      break;
    default:
      label = decision;
      variant = 'secondary';
      break;
  }
  return (
    <Badge variant={variant} className={cn('uppercase', className)}>
      {label}
    </Badge>
  );
} 